import styled from "styled-components";

export const SectionHeaderContainer = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  width: 100%;
`;
